import { get, post } from 'services/api';
import { OrgParamProps, HightouchAllotment } from 'modules/allOrganizations/types';

const ALL_ORGANIZATIONS_URL = '/i/organizations';
const UPDATE_ORGANIZATION_URL = '/i/orgs/';
const HIGHTOUCH_ALLOTMENT_SYNC_LIMIT_URL = '/integrations/hightouch/allotment';

/**
 * fetchAllOrganizations
 * gets a list of all organizations
 * @return { Object[] } List of objects representing organizations
 */
export function fetchAllOrganizations() {
  return get(ALL_ORGANIZATIONS_URL);
}

/**
 * fetchOrganizationUsers
 * gets a list of the users of the organization
 * @return { Object[] } List of users in this organization
 */
export function fetchOrganizationUsers(orgId: number) {
  return get(`/i/orgs/${orgId}/users`);
}

/**
 * updateOrganization
 * updates organization details
 * @return { String } Success message
 */
export function updateOrganization(orgId: OrgParamProps['id'], params: OrgParamProps) {
  return post(`${UPDATE_ORGANIZATION_URL}${orgId}`, params);
}

/**
 * fetchHightouchAllotmentSyncLimit
 * gets the hightouch allotment for the organization.
 * enablement is hidden behind a feature flag: HightouchIntegration
 */
export function fetchHightouchAllotmentSyncLimit(): Promise<HightouchAllotment> {
  return get(HIGHTOUCH_ALLOTMENT_SYNC_LIMIT_URL);
}

/**
 * updateHightouchAllotmentSyncLimit
 * updates the hightouch allotment for the organization.
 * enablement is hidden behind a feature flag: HightouchIntegration
 */
export function updateHightouchAllotmentSyncLimit(syncs: number): Promise<any> {
  return post(HIGHTOUCH_ALLOTMENT_SYNC_LIMIT_URL, { syncs });
}
